import { useCallback, useMemo } from 'react';

import {
  useApproveErc20Token,
  useIsNeedTokenApproval,
  UseIsNeedTokenApprovalParam,
} from './useErc20Read';

export const useRequireAllowance = ({
  requiredAmount,
  tokenAddress,
  spender,
  action,
}: UseIsNeedTokenApprovalParam & {
  action: () => void;
}) => {
  const { data: isRequireAllowance, refetch: refetchApprovalState } =
    useIsNeedTokenApproval({
      requiredAmount,
      tokenAddress,
      spender,
    });
  const { writeContractAsync: requestApproval, isPending } =
    useApproveErc20Token({
      tokenAddress,
      spenderAddress: spender,
    });

  const executeAction = useCallback(async () => {
    if (isRequireAllowance) {
      try {
        await requestApproval();
        refetchApprovalState();
      } catch (e) {
        return;
      }
    }

    return action();
  }, [action, isRequireAllowance, refetchApprovalState, requestApproval]);

  return useMemo(() => {
    return {
      isPending,
      writeContractAsync: executeAction,
    };
  }, [executeAction, isPending]);
};
